const page = `

{settings}
document.title: En hel by tystnar
og.title: En hel by tystnar
og.image: http://quickshot.imgix.net/en-hel-by-tystnar/1.Bilvrak.jpg?w=1000
og.description: Två utbrunna bilvrak står orörda vid infarten till den lilla pakistanska byn Makol utanför staden Abbottabad. Husen ligger tätt, tätt intill varandra i det lilla isolerade bergsområdet och alla här måste ha sett och hört det grymma mordet på 16-åriga Ambreen Riasat. Men Makol har tystnat, då byrådet styr allt – även från fängelset.
og.url: http://pejl.svt.se/en-hel-by-tystnar/
siteCatalyst.name: En hel by tystnar
siteCatalyst.category: lyxartikel
{}

[+page]

{.bild}
fil: en-hel-by-tystnar/1.Bilvrak.jpg
storlek: xl
bildtext: Ambreens livlösa kropp blir buren till en av dessa bilar, där de binder hennes händer vid ratten. Och häller sedan bensin över hennes kropp där hon sitter livlös och fjättrad. Stunden senare brinner flickan och bilen i en våldsam brand.
foto: Niclas Berglund
{}
luft:
rubrik2: En hel by tystnar
rubrikmager: SVT:s Stefan Åsberg skriver om mordet på pakistanska Ambreen

ingress:Två utbrunna bilvrak står orörda vid infarten till den lilla pakistanska byn Makol utanför staden Abbottabad. Husen ligger tätt, tätt intill varandra i det lilla isolerade bergsområdet och alla här måste ha sett och hört det grymma mordet på 16-åriga Ambreen Riasat. Men Makol har tystnat, då byrådet styr allt – även från fängelset.

När vi vandrar längs de slingrande bergsstigarna i Makol känner vi både ilska och lite rädsla. Det är en otäck känsla att besöka en plats där ett så hänsynslöst våld ägt rum mot en hjälplös och oskyldig flicka.
16-åriga Ambreen Riasat hjälpte en kamrat att fly från byn, vilket, enligt polisen, ledde till att byrådet i Makol straffade henne med döden. Det gränslösa våld flickan mötte har fått Pakistan att stanna upp.
Ambreen hämtades från sin familj en sen natt, drogades, ströps och bands sedan fast i en av de där bilarna vid infarten till byn, och bilarna antändes därefter med hjälp av bensin.

{.bild}
fil: en-hel-by-tystnar/fangesquare.jpg
storlek: square
bildtext: Mannen och 14 andra är gripna för mordet på Ambreen. De riskerar nu att bli dömda till döden genom hängning. Fastkedjade och fängslade förs de mordmisstänkta männen ut på fängelsegården.
foto: Niclas Berglund
{}
När vi närmar oss Ambreens gravplats stoppas vi av en man som vill bjuda oss på te. Samtidigt får vi veta att hans far är en av de äldste, en av de mest inflytelserika i byrådet. Alltså en av de, som enligt polisen, plågade Ambreen till döds.
Situationen är overklig. Helst av allt skulle vi vilja visa vår avsky, skrika eller göra vad som helst. Men istället tackar vi bara hövligt nej. Vi har ju också vår egen säkerhet att tänka på.
Vi är ensamma jag, Niclas och vår fixare Asim med Makols 5.000 invånare, och nästan alla har slutit upp bakom byrådet. Här är en 16-årig flickas liv inte mycket värt.

luft:
{.special}
component:Kartbox
text: Ambreen Risat bodde i byn Makol nära staden Abbottabad i Pakistan. Enligt organisationen HBV, som arbetar med herdersrelaterat våld, sker årligen 1000 fall av hedersmord i Pakistan.
bild: pakistan
storlek:text
{}

Flera gånger hindras vi från att ta bilder på kvinnor och varje gång vi möter någon av byns kvinnor stannar de upp och vänder bort sitt ansikte. Vi försöker att hälsa, men får inga svar.
Hederskulturen är fortfarande en del av livet på Pakistans landsbygd. Och i få länder begås fler hedersmord än just här. Enligt ett antal människorättsorganisationer här dödades ifjol fler än 1.100 kvinnor i Pakistan, då de ansågs ha skadat männens heder.
rubrik4: Mordet har startat debatt
När vi närmar oss Ambreens grav har flera av byns män slagit följe med oss och de är misstänksamma. Inga journalister har tillåtits att komma in här tidigare och alla talar om hur viktigt det är att byrådets 13 medlemmar släpps fria. Ingen tycks sakna den unga flickan.
Här är man van vid att fatta sina egna beslut, utan att omvärlden lägger sig i. Men den här gången gick våldet för långt. Mordet på Ambreen har startat en debatt, som kanske på allvar kan förändra saker i grunden.
Starka röster höjs nu för att kvinnors rätt måste stärkas i Pakistan. Kanske dog inte Ambreen förgäves.
{.bild}
fil: en-hel-by-tystnar/5.Moster2.jpg
storlek: xl
bildtext: Flickans moster Narmat, levde nära henne och hon brister i tårar när vi börjar prata om Ambreens öde.
foto: Niclas Berglund
{}
luft:
För oss är det annars en märklig dag. Just innan vi besöker Makol har polisen visat upp de misstänkta. De får inte prata, men ropar ändå till oss att de inte hade något otalt med flickan och att de är oskyldiga.
Männen är rädda nu. Det är ju inte deras uråldriga lagar som styr längre. För första gången ska Makol och deras byråd möta ett någorlunda fungerande rättssystem.
rubrik4: ”Den skyldige ska straffas”
När vi gör oss redo att lämna Makol har ett 20-tal män samlats omkring oss. De vill ta i hand och försäkra sig om att vi förstått att byns styrande är helt oskyldiga.
Det känns olustigt. Vi svarar inte på deras frågor, men tvingas ta alla omkring oss i hand. För oss känns det som alla är skyldiga. Ingen försökte ju att rädda flickan.

En enda kvinna talade förresten med oss under vårt besök i Makol. Det var Ambreens moster som sa:
– Vem som än är skyldig ska straffas. På samma sätt som Ambreen dog.
Det var på alla sätt ett modigt svar.
luft:60px
{.bild}
fil: en-hel-by-tystnar/byline.jpg
storlek: m
imgix.crop:faces
{}
text:Av: [Niclas Berglund |  mailto:niclas.berglund@svt.se ] och [Stefan Åsberg|  mailto:stefan.asberg@svt.se]

`;

export default page;








/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/en-hel-by-tystnar.js
 **/